import React from 'react'
import { ButtonEditInline } from '../../../../../Components/Buttons/ButtonEditInline'
import { ButtonArchiveInline } from '../../../../../Components/Buttons/ButtonArchiveInline'
import { Ticked } from 'Components/Ticked'
import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import { theme } from 'Assets/Styles/theme'
import * as CONST from '../../../../../Reducers/Location/const'
import { LinkView } from '../../../../../Components/Link/View'
import { getLocationProfileLink } from '../../../../../Utils/Link'

const LocationRow = ({
  location,
  handleModalArchiveShow,
  handleModalEditShow,
  cityId,
  isH2H,
}) => {
  const isArchived = location.status === CONST.LOCATION_STATUS[2].value
  const archivedColor = isArchived ? theme.colors.primary : null
  const archivedName = isArchived ? ' (Archived)' : ''
  return (
    <Tr key={`location-row-${location.id}`}>
      <Td color={archivedColor}>{location.name + archivedName}</Td>
      <Td color={archivedColor}>{location.label}</Td>
      <Td color={archivedColor}>{location.type.name}</Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.morning} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.lunch} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.afternoon} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.isSheltered} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.isEvent} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.hasPermit} />
      </Td>
      <Td className="align-right no-opacity">
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          {isH2H ? (
            <LinkView
              className="link-view"
              onClick={() => {
                const url = getLocationProfileLink(cityId, location.id)
                window.open(url, '_blank').focus()
              }}
            />
          ) : null}
          <ButtonEditInline
            onClickHandler={() => handleModalEditShow(location.id)}
          />
          {!isArchived && (
            <ButtonArchiveInline
              onClickHandler={() => handleModalArchiveShow(location.id)}
              title="Archive location"
            />
          )}
        </div>
      </Td>
    </Tr>
  )
}

export default LocationRow
